var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('h2',{staticClass:"heading2"},[_vm._v(_vm._s(_vm.data.heading))]),_vm._v(" "),_c('br'),_c('p',[_vm._v(_vm._s(_vm.data.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }